import React from 'react';
import { BULK_UPLOAD_IMAGE_MAX_COUNT } from '../../shared/constants/limits';
import { getPageMessage } from '../../shared/constants/pageMessages';
import ImageDropLayer from '../../shared/component/ImageDropLayer';

interface DragDropLayerProps {
  dragState: 'list' | 'viewer' | null;
}

const DragDropLayer: React.FC<DragDropLayerProps> = ({ dragState }) => {
  const dropTextKey = dragState === 'list' ? 'DRAG_DROP_CREATE_WORK' : 'DRAG_DROP_CREATE_DETAIL';

  return (
    <ImageDropLayer
      isVisible={dragState !== null}
      title={getPageMessage(dropTextKey)}
      description={getPageMessage('DRAG_DROP_LIMIT_TEXT', {
        maxCount: BULK_UPLOAD_IMAGE_MAX_COUNT,
      })}
    />
  );
};

export default DragDropLayer;
